import $ from 'jquery';

export default class Tab {
    /**
     * @param $container Container that contains all tabs and its content
     * @param $tabs List of all tabs in container
     * @param $content List of all contents of tab in container
     * @param options Additional options
     */

    constructor($container, options) {
        this.options = $.extend(true, {
            classes: {
                tabOpened: 'btn--navy',
                tabClosed: 'btn--light',
                contentOpened: 'tabs__content--opened',
            },
        }, options);

        if (!$container) {
            return;
        }

        this.$container = $container;
        this.$tabs = [...$container.querySelectorAll('.tabs__item')];
        this.$content = [...$container.querySelectorAll('.tabs__content')];

        this.init();
    }

    init() {
        this.initTabs();
    }

    initTabs() {
        this.$tabs.forEach(($tab) => {
            this.eventHandleToggle($tab);
            if ($tab.getAttribute("data-id") === "1") this.open($tab);
        });
    }

    open($tab) {
        this.$tabs.forEach($t => {
            $t.classList.remove(this.options.classes.tabOpened);
            $t.classList.add(this.options.classes.tabClosed);
        })
        $tab.classList.remove(this.options.classes.tabClosed);
        $tab.classList.add(this.options.classes.tabOpened);

        this.$content.forEach($c => {
            if ($c.getAttribute("data-content") === $tab.getAttribute("data-id")) {
                $c.classList.add(this.options.classes.contentOpened);
            } else {
                $c.classList.remove(this.options.classes.contentOpened);
            }
        })
    }

    eventHandleToggle($tab) {
        const handler = (e) => {
            e.preventDefault();
            this.open($tab);
        }

        $tab.addEventListener('click', handler);
    }
}


// WEBPACK FOOTER //
// ./front/treasurybond/js/common/tabs.js